import React, { useState } from 'react';
import { Modal, Button, Input, Select } from '../../components/ds';
import api from '../../api/client';

const TIMEZONES = [
  'Asia/Taipei',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Singapore',
  'Asia/Seoul',
  'America/New_York',
  'America/Los_Angeles',
  'Europe/London',
  'UTC',
];

export default function CreateAccountModal({ onClose, onCreated }) {
  const [form, setForm] = useState({
    account_name: '',
    timezone: 'Asia/Taipei',
    user_name: '',
    email: '',
    password: '',
  });
  const [features, setFeatures] = useState({
    targeting: {
      frequency_cap: true,
      day_parts: true,
      keywords: true,
      audience: false,
    },
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await api.createAccount(form);
      try {
        await api.updateAccountFeatures(data.accountID, features);
      } catch {
        // Features will use defaults if this fails
      }
      onCreated(data.accountID);
    } catch (err) {
      setError(err.message || '建立帳號失敗：');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title="建立帳號" onClose={onClose} footer={
      <>
        <Button variant="secondary" onClick={onClose}>取消</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? '建立中...' : '建立'}
        </Button>
      </>
    }>
      <form onSubmit={handleSubmit}>
        <h3 style={{ marginBottom: 12, fontSize: 15, color: 'var(--text-secondary)' }}>
          帳號資訊
        </h3>

        <Input
          label="帳號名稱 *"
          value={form.account_name}
          onChange={handleChange('account_name')}
          placeholder="輸入帳號名稱"
          required
        />

        <Select
          label="時區 *"
          value={form.timezone}
          onChange={handleChange('timezone')}
          options={TIMEZONES.map((tz) => ({ value: tz, label: tz }))}
        />

        <h3 style={{ marginBottom: 12, marginTop: 24, fontSize: 15, color: 'var(--text-secondary)' }}>
          首位管理者
        </h3>

        <Input
          label="使用者名稱 *"
          value={form.user_name}
          onChange={handleChange('user_name')}
          placeholder="輸入使用者名稱"
          required
        />

        <Input
          label="Email *"
          type="email"
          value={form.email}
          onChange={handleChange('email')}
          placeholder="輸入 Email"
          required
        />

        <Input
          label="密碼 *"
          type="password"
          value={form.password}
          onChange={handleChange('password')}
          placeholder="輸入密碼"
          required
        />

        <h3 style={{ marginBottom: 12, marginTop: 24, fontSize: 15, color: 'var(--text-secondary)' }}>
          功能設定 — Targeting
        </h3>

        {[
          { key: 'frequency_cap', label: '頻次控制' },
          { key: 'day_parts', label: '時段鎖定' },
          { key: 'keywords', label: '關鍵字' },
          { key: 'audience', label: '受眾' },
        ].map((opt) => (
          <label
            key={opt.key}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '8px 12px',
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer',
              border: '1px solid var(--border-color)',
              marginBottom: 8,
              backgroundColor: features.targeting[opt.key] ? 'var(--bg-secondary)' : 'transparent',
            }}
          >
            <input
              type="checkbox"
              checked={features.targeting[opt.key] || false}
              onChange={() =>
                setFeatures((prev) => ({
                  ...prev,
                  targeting: {
                    ...prev.targeting,
                    [opt.key]: !prev.targeting[opt.key],
                  },
                }))
              }
              style={{ width: 18, height: 18 }}
            />
            <span style={{ fontWeight: 500 }}>{opt.label}</span>
          </label>
        ))}

        {error && <div className="error-text">{error}</div>}
      </form>
    </Modal>
  );
}
